import { MenuItemDto } from '../../api-types';
import { capitalizeFirstLetter } from '../../utils/capitalizeCase';
import { FoodIcon } from '../foodIcon';
import { ReactNode } from 'react';

interface IProps {
    menuItem: MenuItemDto;
}

export function DishItem({ menuItem }: Readonly<IProps>): ReactNode {
    return (
        <div className='menu-item-main'>
            <FoodIcon
                foodType={menuItem.icon}
                color={menuItem.icon.toLowerCase()}
            />
            <div className='menu-item-name' role='menu-item-name'>
                {capitalizeFirstLetter(menuItem.title)}
            </div>
        </div>
    );
}
